import request from '@/utils/httpRequest'

export default class DeratedService {
  queryById(id) {
    return request({
      url: '/finance/wuyeFinanceDerated/queryById',
      method: 'get',
      params: { id: id }
    })
  }
  
  startFlow (params) {
    return request({
      url: '/finance/wuyeFinanceDerated/startFlow',
      method: 'post',
      data: params
    })
  }
}
